module.exports = __webpack_public_path__ + "img/d4bc132cd091a227bc3b628646a32dd3.png";